import { createFileRoute, redirect } from "@tanstack/react-router";

import { ConflictsPage } from "@/features/fleet/ConflictsPage";

export const Route = createFileRoute("/_app/conflicts")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "cloud" || !context.me?.permissions.includes("devices.manage")) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: ConflictsPage,
});
